import Vue from 'vue';
import { Keys } from "../plugins/globalConstants";

Vue.i18n.add('fr', require('./fr.json'));
Vue.i18n.add('en', require('./en.json'));
Vue.i18n.add('pl', require('./pl.json'));
Vue.use(Keys);

// set the start locale to use
let locale = localStorage.getItem(Vue.Keys.LANGUAGE);
if(!locale){
    locale = process.env.VUE_APP_DEFAULT_LANGUAGE;
    localStorage.setItem(Vue.Keys.LANGUAGE, locale);
}
Vue.i18n.set(locale);

// set fallback for non-translated strings
Vue.i18n.fallback(locale);
